import dayjs from 'dayjs';
import { optional, tryNewDate } from '@/helpers/dto2resource';
import ServerTimeService from '@/services/ServerTimeService';
import BoletoDto from '../dto/BoletoDto';
import StatusBoleto from '../enums/StatusBoleto';

export default class BoletoResource {
  id: number;
  dataVencimento?: Date;
  valor?: number;
  numeroParcela: number;

  /** linha digitável de boleto */
  linhaDigitavel?: string;
  /** url para download de boleto */
  url?: string;
  /** código copia-e-cola de pix */
  copiaECola?: string;
  /** url para download do documento pix */
  urlPix?: string;

  pago?: boolean;
  quitada?: boolean;
  detalhe: unknown;
  dataCriacao?: Date;
  dataPagamento?: Date;
  observacoes?: string;
  permiteGeracaoBoleto?: boolean;
  emissaoSuspensa?: boolean;

  constructor(resource: BoletoDto) {
    this.id = resource.id;
    this.dataVencimento = tryNewDate(resource.dataVencimento);
    this.valor = optional(resource.valor);
    this.numeroParcela = resource.numeroParcela;

    this.linhaDigitavel = optional(resource.linhaDigitavel);
    this.url = optional(resource.url);
    this.copiaECola = optional(resource.copiaECola);
    this.urlPix = optional(resource.urlPix);

    this.pago = optional(resource.pago);
    this.quitada = optional(resource.quitada ?? resource.pago);
    this.detalhe = resource.detalhe;
    this.dataCriacao = tryNewDate(resource.dataCriacao);
    this.dataPagamento = tryNewDate(resource.dataPagamento);
    this.observacoes = optional(resource.observacoes);
    this.permiteGeracaoBoleto = optional(resource.permiteGeracaoBoleto);
    this.emissaoSuspensa = optional(resource.emissaoSuspensa);
  }

  get status(): StatusBoleto {
    if (this.quitada) {
      return StatusBoleto.Quitado;
    }

    if (this.pago) {
      return StatusBoleto.PagoParcialmente;
    }

    if (dayjs(ServerTimeService.syncedTime).diff(dayjs(this.dataVencimento), 'day') > 0) {
      return StatusBoleto.Vencido;
    }

    return StatusBoleto.Aberto;
  }

  get boletoEmitido(): boolean {
    return !!(this.url || this.linhaDigitavel);
  }

  get pixEmitido(): boolean {
    return !!this.copiaECola;
  }

  get pagoParcialmente() {
    return this.pago && !this.quitada;
  }
}
